var NAME_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;
function requireName(name) {
  if (typeof name !== "string" || !NAME_PATTERN.test(name)) {
    throw new Error("Database.openKeyValue: name must be 1-128 letters, digits, dots, underscores, or hyphens");
  }
  return name;
}
function requireKey(verb, key) {
  if (typeof key !== "string" || key === "") {
    throw new Error(`${verb}: key must be a non-empty string`);
  }
  return key;
}
function requireValue(verb, value) {
  if (typeof value !== "string") {
    throw new Error(`${verb}: value must be a string`);
  }
  return value;
}
function assertOpen(verb, closed) {
  if (closed) throw new Error(`${verb}: key-value store is closed`);
}
export {
  assertOpen,
  requireKey,
  requireName,
  requireValue
};
//# sourceMappingURL=keyValueValidate.js.map
